import { SolaView, htmlSolaWithInstance } from '@hm-spt/sola';

interface DashboardData {
  message: string;
}

/**
 * 대시보드 — placeholder.
 *
 * Phase B/C 에 위젯들 추가 예정:
 *   - 오늘 입고/출고 카운트
 *   - 만료 임박 공급사 견적
 *   - 최근 활동 로그
 *   - 재고 부족·가격 변동 알림
 */
export class DashboardView extends SolaView<DashboardData> {
  constructor() {
    super();
    this.data = { message: '대시보드 — Phase B 에서 위젯 구현 예정' };
  }

  override getTitle(): string {
    return 'HCLTech 어드민';
  }

  render(): HTMLElement {
    return htmlSolaWithInstance(this)`
      <div class="page page-dashboard">
        <header class="page-header">
          <h1>🏠 대시보드</h1>
        </header>
        <section class="page-body">
          <div class="placeholder-card">
            <h2>곧 구현 예정 위젯</h2>
            <ul>
              <li>오늘 입고 / 출고 카운트</li>
              <li>만료 임박 공급사 견적</li>
              <li>최근 활동 로그</li>
              <li>재고 부족 알림</li>
              <li>가격 변동 큰 SKU</li>
            </ul>
            <p class="placeholder-hint">
              상단 사이드바로 다른 페이지 이동 가능 — 카탈로그는 이미 작동합니다.
            </p>
          </div>
        </section>
      </div>
    `;
  }
}
